import { render } from "./StallionListView.vue?vue&type=template&id=2c15b87b&scoped=true"
import script from "./StallionListView.vue?vue&type=script&lang=js"
export * from "./StallionListView.vue?vue&type=script&lang=js"

import "./StallionListView.vue?vue&type=style&index=0&id=2c15b87b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c15b87b"]])

export default __exports__